import React from 'react';
import Icon from '../../../components/AppIcon';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

const KPICard = ({ title, value, change, trend, icon, iconColor, sparklineData }) => {
  const isPositive = change >= 0;
  const changeColor = isPositive ? 'text-success' : 'text-error';
  const changeIcon = isPositive ? 'TrendingUp' : 'TrendingDown';

  return (
    <div className="card h-full">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div 
            className="w-12 h-12 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${iconColor}15` }}
          >
            <Icon name={icon} size={24} color={iconColor} />
          </div>
          <div>
            <p className="caption text-muted-foreground mb-1">{title}</p>
            <h2 className="text-3xl font-bold text-foreground">{value}</h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name={changeIcon} size={16} className={changeColor} />
          <span className={`text-sm font-semibold ${changeColor}`}>
            {Math.abs(change)}%
          </span>
          <span className="caption text-muted-foreground">{trend}</span>
        </div>

        {sparklineData && sparklineData?.length > 0 && (
          <div className="w-24 h-12">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={sparklineData}>
                <Line 
                  type="monotone" 
                  dataKey="value" 
                  stroke={isPositive ? 'var(--color-success)' : 'var(--color-error)'} 
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;